module.exports = __webpack_public_path__ + "static/img/Ruchika.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Ruchika.png
// module id = XKPJ
// module chunks = 1